import { createFileRoute } from '@tanstack/react-router';
import { EmployeeLeave } from '@/components/employee/leave';

export const Route = createFileRoute('/(app)/employee/leave/')({
  component: EmployeeLeaveRoute,
});

function EmployeeLeaveRoute() {
  return <EmployeeLeave showBackButton={false} />;
}
